import { render, staticRenderFns } from "./mainCategoryManage.vue?vue&type=template&id=15c3adf6&scoped=true"
import script from "./mainCategoryManage.vue?vue&type=script&lang=js"
export * from "./mainCategoryManage.vue?vue&type=script&lang=js"
import style0 from "./mainCategoryManage.vue?vue&type=style&index=0&id=15c3adf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c3adf6",
  null
  
)

export default component.exports